import { NavbarComponent } from "./components/Navbar";
import { BrowserRouter, useRoutes, useNavigate } from "react-router-dom";
import { Login } from "./pages/Login";
import { Projects } from "./pages/Projects";
import { Environment } from "./pages/Environment";
import { FAQ } from "./pages/FAQ";
import { UserProvider, UserContext } from "./utils/UserContext";
import { UserManagement } from "./pages/UserManagement";
import { FooterComponent } from "./components/Footer";
import { ErrorProvider } from "./contexts/ErrorContext";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Background from "./components/Background";

const AppRoutes = () => {
  const routes = useRoutes([
    { path: "/login", element: <Login /> },
    { path: "/register", element: <Register /> },
    {
      path: "/projects",
      element: <Projects />,
    },
    {
      path: "/home",
      element: <Home />,
    },
    {
      path: "/environment",
      element: <Environment />,
    },
    {
      path: "/faq",
      element: <FAQ />,
    },
    {
      path: "/users",
      element: <UserManagement />,
    },
    {
      path: "/*",
      element: <Login />,
    },
  ]);

  return routes;
};

function App() {
  return (
    <>
      <BrowserRouter>
        <UserProvider>
          <NavbarComponent />
          <section className="relative min-h-screen  bg-transparent lg:pb-[90px] lg:pt-[10px]">
            <ErrorProvider>
              <AppRoutes />
              <Background />
            </ErrorProvider>
          </section>
          <FooterComponent />
        </UserProvider>
      </BrowserRouter>
    </>
  );
}
export default App;
